<template>
	<div id="app" class="lapp">
		<!--头部——导航-->
		<div class="lnav">
			<div class="lnav_store">
				<div class="lstore_button" @click="lnav_Jfshch">积分商城</div>
			</div>
			<div class="lnav_logo">
				<div style="width: 100%;" @mouseenter="leave()">
					<img class="llogo" src="./assets/LRimg/nav_logo.png">
				</div>
				<ul class="lnavbar" id="except">
					<li v-for="(item,index) in lnavList" :class="{'lline':item.id==checkindex}" :key="index" @click="ltoggletab(item)" @mouseenter="enter(item)" @mouseleave="leave1(item)">
						<span>{{item.name}}</span>
					</li>
				</ul>
				<!-- 产品的导航 -->
				<div class="lseth_nav except" v-show="lseth_nav1" @mouseleave="leave()">
					<div class="lseth_content clear" id="lproduct">
						<ul class="lseth_conleft" v-for="(item,index) in cProductlist" :key="index">
							<!--<span v-if="item.label == '推荐'" style="opacity: 0;">系列</span>-->
							<li @click="jump(item.id)" v-if="item.label != '推荐'">{{item.label}}</li>
						</ul>
					</div>
				</div>

				<!-- 美肌学堂的导航 -->
				<div class="lseth_nav except" v-show="lseth_nav2" @mouseleave="leave()">
					<div class="lseth_content clear" id="lmj">
						<ul class="lseth_conleft" v-for="(item,index) in cProductvideo" :key="index">
							<li v-if="item.name != '积分兑换'" @click="ljump(item.id)">{{item.name}}<span v-if="item.name == '全部'" style="opacity: 0;">系列</span></li>
						</ul>
					</div>
				</div>
			</div>
		</div>
		<!--中部——内容-->
		<router-view v-if="isRouterAlive" :class="{ 'lopacity': lselect }"></router-view>
		<!--尾部——版权介绍-->
		<div class="lcopyright">
			<div class="lcopy clear">
				<!--左边-->
				<div class="lcopy_left">
					<div class="lcustomer">客服服务</div>
					<ul class="lcopy_nav clear">
						<li>职业生涯</li>
						<li @click="contactUs()">联系我们</li>
						<li @click="contact()">使用条款</li>
						<li @click="lnav_Shoppe">{{lnav_shoppe.name}}</li>
						<li @click="contact_img()">官方图片</li>
					</ul>
					<div class="lcopy_title">版权</div>
					<div class="lcopy_firm">&copy;2018 上海麦缌投资管理有限公司
						<a href="http://www.miitbeian.gov.cn" target="_blank">沪ICP备13025541号-2</a>
					</div>
				</div>
				<!--右边-->
				<div class="lcopy_right">
					<div class="lcustomer">关注微信公众号</div>
					<img class="lerweima" src="./assets/LRimg/erweima.png">
				</div>
			</div>
		</div>
		<!-- 模态框 -->
		<div id="modal1" class="modal1" v-show="modal1">
			<div class="modal-content">
				<span @click="closeModal1()" class="close">×</span>
				<h6>使用条款</h6>
				<p class="p1">本网站【域名：http://www.anab.com.cn】（以下称“本网站”）由上海麦缌投资管理有限公司制作并发布。该公司在中国，上海市闵行区市场监督管理局登记注册，统一社会信用代码为91310112697250869T，作为一家有限责任公司（自然人投资或控股），其总部位于上海，拥有价值500万元的股本资金。出版人及总编：Valérie Loh，国际网站经理、客户关系管理与媒体总监。网站由LINKBYNET 主持，本网站访客进入本网站及使用其内容即表示其无条件接受并遵守以下的条款：</p>

				<p>1．本网站是上海麦缌投资管理有限公司的专有财产，其为唯一原有或是经授权而有权利使用其相关知识产权与人格权的实体，包括但不限于商标、著作权与肖像权。</p>
				<p>2. 严格禁止自然人、法人和非法人组织将本网站的全部或部分内容用于商业用途，尤其是下载、复制、传送、展示或其它用途。</p>
				<p>3. 上海麦缌投资管理有限公司承诺尽力保证展示在网站上的信息是正确且最新的。上海麦缌投资管理有限公司保留随时更新网站内容的权利。但是，上海麦缌投资管理有限公司不保证网站上数据的正确性、准确性与完整性。</p>
				<p class="p2">因此，上海麦缌投资管理有限公司对包括但不限于以下任何内容不承担责任：网站所提供之数据的任何不严密、不精确或疏漏；因第三方入侵修改网站资料而导致的任何损失；起因于进入或无法进入网站，以及使用网站及/或直接或间接透过网站提供之信用数据，所产生的任何直接或间接损失，不论其原因、来源、性质或后果。</p>

				<p class="p3">就访问本网站或关于本网站内容有任何问题请通过如下方式与上海麦缌投资管理有限公司联系：
					<br> 电话：021-62780567；
					<br> 邮箱：service@maisigroup.cn
				</p>

				<p>2018.06.01 2:18 pm</p>

			</div>
		</div>
		<!-- 返回顶部 -->
		<span class="backTop" @click="backToTop()" v-show="backTop"><img src="./assets/YTimg/icon/B011/Back.png" alt=""></span>
	</div>
</template>

<script>
	import Swiper from "swiper";
	export default {
		name: "app",
		components: {},
		data() {
			return {
				cProductlist: {}, //商品导航
				cProductvideo: {}, //视频导航

				//是否刷新
				isRouterAlive: true,
				//导航栏
				checkindex: 0,
				isShowTwo: 0,
				isShowThree: 0,
				//二级菜单的显示隐藏
				lseth_nav1: false,
				lseth_nav2: false,
				lselect: false,
				backTop: false,
				modal1: false,
				//一级菜单、二级菜单、三级菜单（导航栏）
				lnavList: [
					{
						name: "首页",
						route: "/",
						id:0
					},
					{
						name: "产品",
						route: "/product/product",
						id:1
					},
					{
						name: "美肌学堂",
						route: "/mj_school/mj_school",
						id:2
					},
					{
						name: "最新资讯",
						route: "/new_consult/new_consult",
						id:3
					},
					{
						name: "AnaB爱柔肤",
						route: "/anab/anab",
						id:4
					},
					//					{
					//						name: "积分商城",
					//						route: ""
					//					}
				],
				lnav_shoppe: {
					name: "门店专柜",
					route: "/shoppe/shoppe"
				},
				lmg: {
					name: "官方图片",
					route: "/lr_img/lr_img"
				}
			};
		},

		mounted() {
			window.addEventListener('scroll', this.scrollToTop)
			this.getData();
			this.getData1();
		},
		methods: {
			//data
			//数据
			//商品导航
			getData() {
				this.$http.get('http://abc.anab.com.cn/abc/cProductCategory/listTrendingTop').then(res => {
					//					console.log(res.data.data.items);
					this.cProductlist = res.data.data.items;
//					console.log(this.cProductlist)

				}, response => {
					console.log("error");
				});
			},
			//视频导航
			getData1() {
				this.$http.get('http://abc.anab.com.cn/abc/cProductCategory/cGetCategoryList').then(res => {
					//					console.log(res.data.data);
					this.cProductvideo = res.data.data;
//					console.log(this.cProductvideo)
				}, response => {
					console.log("error");
				});
			},
			// 备案

			//导航栏切换路由跳转
			ltoggletab(item) {
				console.log("++++++++")
				//点击的导航高亮
				this.checkindex = item.id;
				//路由跳转
				let path = item.route;
//				console.log(item.name)
				//				if(item.name == "积分商城") {
				//					console.log(111111111)
				//					location.href='http://wap.anab.com.cn/'
				//					window.open ('http://wap.anab.com.cn/')
				//				} else {
				this.$router.push({
					path: path
				});
				//				}
			},

			//			GetWidth(){
			//				var liwidth=$("#except>li").outerWidth();
			//				console.log(liwidth)
			//
			//			},
			//二级导航的悬停事件
			enter(item) {
				this.checkindex = item.id;
				if(item.name == " 首页") {
					this.lseth_nav1 = false;
					this.lseth_nav2 = false;
					this.lselect = true;
				} else if(item.name == "产品") {
					this.lseth_nav2 = false;
					this.lseth_nav1 = true;
					this.lselect = true;
				} else if(item.name == "美肌学堂") {
					this.lseth_nav1 = false;
					this.lseth_nav2 = true;
					this.lselect = false;
				} else if(item.name == "最新资讯") {
					this.lseth_nav1 = false;
					this.lseth_nav2 = false;
					this.lselect = false;
				} else if(item.name == "AnaB爱柔肤") {
					this.lseth_nav1 = false;
					this.lseth_nav2 = false;
					this.lselect = false;
				}
			},
			leave1(item) {
				this.lselect = false;
			},

			leave() {
				this.lseth_nav1 = false;
				this.lseth_nav2 = false;
				this.lselect = false;
			},

			//积分商城
			lnav_Jfshch() {
				window.open('http://wap.anab.com.cn/')
			},

			//门店专柜
			lnav_Shoppe() {
				let path = this.lnav_shoppe.route;
				this.checkindex = undefined;
				//        console.log(path);
				this.$router.push({
					path: path
				});
			},

			//官方图片的跳转
			contact_img() {
				let path = this.lmg.route;
				this.checkindex = undefined;
				//        console.log(path);
				this.$router.push({
					path: path
				});
			},

			//刷新
			reload() {
				this.isRouterAlive = false
				this.$nextTick(() => (this.isRouterAlive = true))
			},
			//跳转
			//产品
			jump(id){
				console.log(id)
				this.lseth_nav1 = false;
				this.lseth_nav2 = false;
				this.lselect = false;
				this.reload()
				this.$router.push({
					path: '/product/product_list/' + id,
					params: {
						id: id,
					}
				})
			},
			//视频
			ljump(id){
//				console.log(id)
				this.lseth_nav1 = false;
				this.lseth_nav2 = false;
				this.lselect = false;
				this.reload()
				this.$router.push({
					path: '/mj_school/singleProduct/' + id,
					params: {
						id: id,
					}
				})
			},
			
			// 滚动条
			scrollToTop() {
				var scrollTop = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop;
				// 　　console.log(scrollTop)
				if(scrollTop >= 400) {
					this.backTop = true;
				} else {
					this.backTop = false;
				}
			},
			// 返回顶部
			backToTop() {
				document.body.scrollTop = 0
				document.documentElement.scrollTop = 0
			},
			//路由监听
//			getPath() {
//				if(this.$route.path == '/') {
//					this.checkindex = 0;
//				} else if(this.$route.path == '/product/product') {
//					this.checkindex = 1;
//				} else if(this.$route.path == '/mj_school/mj_school') {
//					console.log(3333);
//					this.checkindex = 2;
//				} else if(this.$route.path == '/new_consult/new_consult') {
//					this.checkindex = 2;
//				} else if(this.$route.path == '/anab/anab') {
//					this.checkindex = 3;
//				} else if(this.$route.path == '/product/product_list/1') { //畅销产品
//					this.checkindex = 1;
//				} else if(this.$route.path == '/product/product_list/2') { //新品上市
//					this.checkindex = 1;
//				}
//				//产品详情
//				else if(this.$route.path == '/mj_school/mj_schoolDetails/3/0') {
//					this.checkindex = 1;
//				} else if(this.$route.path == '/mj_school/mj_schoolDetails/4/3') {
//					this.checkindex = 1;
//				} else if(this.$route.path == '/mj_school/mj_schoolDetails/4/1') {
//					this.checkindex = 1;
//				} else if(this.$route.path == '/mj_school/mj_schoolDetails/10/0') {
//					this.checkindex = 1;
//				} else if(this.$route.path == '/mj_school/mj_schoolDetails/8/1') {
//					this.checkindex = 1;
//				} else if(this.$route.path == '/mj_school/mj_schoolDetails/8/0') {
//					this.checkindex = 1;
//				}
//			},
			// 使用条款
			contact() {
				this.modal1 = true;
				console.log(111)
			},
			closeModal1() {
				this.modal1 = false
			},
			contactUs() {
				this.$router.push({
					name: 'Terms'
				})
			}
		},
		// 返回顶部
		destroyed() {
			window.removeEventListener('scroll', this.scrollToTop);
		},
		watch: {
//			'$route': 'getPath'
		},
	};
</script>

<style>
	/*公共样式_start*/
	
	* {
		padding: 0;
		margin: 0;
		box-sizing: border-box;
		-moz-box-sizing: border-box;
		/* Firefox */
		-webkit-box-sizing: border-box;
	}
	
	html,
	body {
		width: 100%;
		font-family: "微软雅黑";
		/*font-size: 150px;*/
	}
	
	ul,
	ol {
		list-style: none;
		font-family: "微软雅黑";
	}
	
	a {
		text-decoration: none;
		font-family: "微软雅黑";
	}
	
	a:hover,
	a:active,
	a:visited,
	a:link {
		text-decoration: none;
	}
	
	.clear:after {
		display: table;
		clear: both;
		content: "";
	}
	/* 中心 */
	
	.lcontent {
		position: relative;
		font-family: "Avenir", Helvetica, Arial, sans-serif;
		-webkit-font-smoothing: antialiased;
		-moz-osx-font-smoothing: grayscale;
		width: 90%;
		margin: 0 auto;
	}
	/*公共样式_end*/
	
	.lopacity {
		opacity: 0.5;
	}
	
	.lhome {
		color: #9e9e9e;
		cursor: pointer;
	}
	
	.lapp {
		margin: 0;
		padding: 0;
	}
	/*导航nav*/
	
	.lnav {
		width: 100%;
	}
	
	.lnav_store {
		height: 0.5rem;
		width: 100%;
		background: black;
	}
	
	.lstore_button {
		color: #9fa0a0;
		line-height: 0.5rem;
		float: right;
		padding-right: .5rem;
		cursor: pointer;
		font-size: 0.19rem;
	}
	
	.lnav_logo {
		width: 100%;
		background: white;
		margin-bottom: 0.7rem;
		position: relative;
	}
	
	.llogo {
		display: block;
		height: 0.7rem;
		width: 0.87rem;
		margin: 0.7rem auto;
	}
	
	.lnavbar {
		height: 0.35rem;
		/*width: 520px;*/
		width: 8.5rem;
		margin: 0 auto;
		border-bottom: 1px #eeeeee solid;
	}
	
	.lnavbar>li {
		float: left;
		height: 0.35rem;
		margin-left: 0.38rem;
		text-align: center;
		color: #999;
		cursor: pointer;
		padding: 0 0.15rem 0;
		font-size: 0.19rem !important;
		position: relative;
	}
	
	.lnavbar li:first-child {
		margin-left: .70rem !important;
	}
	
	.lline {
		border-bottom: 1px #191919 solid;
		color: #191919 !important;
		transition: border-bottom 3s;
		-moz-transition: border-bottom 3s;
		/* Firefox 4 */
		-webkit-transition: border-bottom 3s;
		/* Safari 和 Chrome */
		-o-transition: border-bottom 3s;
	}
	/*二三级菜单s*/
	
	.lsecond_menu {
		position: absolute;
		top: 0.5rem;
		width: 100%;
		margin-left: -0.15rem;
	}
	/*子菜单*/
	
	.lmenu_lr {
		margin: 0 auto;
	}
	
	.lsemenu {
		font-size: 0.17rem;
	}
	
	.lsemenu>div {
		margin-bottom: 0.5rem;
		position: relative;
		/*width: 1.25rem;*/
	}
	
	.lthimenu_lr {
		position: absolute;
		/*margin-left: .50rem;*/
	}
	/*二三级菜单e*/
	
	.lseth_nav {
		width: 100%;
		font-size: 0.15rem;
		position: absolute;
		z-index: 100;
		background: #fff;
		color: #999;
	}
	
	.lseth_nav li:hover {
		color: #191919 !important;
	}
	
	.lseth_content {
		width: 8rem;
		margin: 0 auto;
		padding: 0.3rem 0;
	}
	
	.lseth_content li {
		padding: 0.1rem 0;
		cursor: pointer;
	}
	
	.lseth_conleft {
		float: left;
		margin-left: 1.9rem;
	}
	
	.lseth_conright {
		float: left;
		margin-left: 1.9rem;
	}
	/*版权内容copyright*/
	
	.lcopyright {
		height: 4.26rem;
		width: 100%;
		background: #f6f6f6;
		position: relative;
	}
	
	.lcopy {
		height: 1.33rem;
		width: 60%;
		position: absolute;
		top: 50%;
		left: 50%;
		transform: translate(-50%, -50%);
		-webkit-transform: translate(-50%, -50%);
		-ms-transform: translate(-50%, -50%);
	}
	/*左边内容*/
	
	.lcopy_left {
		float: left;
	}
	/*客服服务*/
	
	.lcustomer {
		/*font-size: .14rem;*/
		font-size: 14px;
		color: #191919;
	}
	
	.lcopy_nav {
		margin-top: 0.1rem;
		font-size: 0.12rem;
	}
	
	.lcopy_nav li {
		float: left;
		margin-right: 0.31rem;
		cursor: pointer;
	}
	
	.lcopy_nav a {
		color: #383838;
		/*font-size: .12rem;*/
		font-size: 12px;
	}
	/*版权*/
	
	.lcopy_title {
		font-size: 0.14rem;
		color: #191919;
		margin-top: 0.35rem;
	}
	
	.lcopy_firm {
		color: #383838;
		font-size: 0.12rem;
		margin-top: 0.13rem;
	}
	
	.lcopy_firm a {
		color: #383838;
	}
	/*/右边内容*/
	
	.lcopy_right {
		float: right;
		text-align: center;
		position: relative;
	}
	
	.lerweima {
		height: 1.11rem;
		width: 1.12rem;
		display: block;
		margin-top: 0.18rem;
		position: absolute;
		top: 320%;
		left: 50%;
		transform: translate(-50%, -50%);
		-webkit-transform: translate(-50%, -50%);
		-ms-transform: translate(-50%, -50%);
	}
	
	.backTop {
		position: fixed;
		top: 85%;
		right: 1%;
		cursor: pointer;
	}
	/* 模态框 */
	
	.modal1 {
		width: 100%;
		height: 100%;
		position: fixed;
		left: 0;
		top: 0;
		z-index: 1000;
		background-color: rgba(0, 0, 0, 0.5);
	}
	
	.modal1 .modal-content {
		position: relative;
		display: flex;
		flex-flow: column nowrap;
		justify-content: space-between;
		width: 60%;
		padding: 1.05rem;
		height: 80%;
		margin: 1rem auto;
		padding-top: 0.5rem;
		background-color: #fff;
		-webkit-animation: zoom 0.6s;
		animation: zoom 0.6s;
		resize: both;
		overflow: visible;
		font-family: MicrosoftYaHei;
		color: #666;
	}
	
	.modal1 .modal-content h6 {
		text-align: center;
		font-size: 0.39rem;
		color: #000;
	}
	
	.modal1 .modal-content .p1 {
		margin-top: 0.45rem;
		margin-bottom: 0.33rem;
	}
	
	.modal1 .modal-content .p2 {
		margin-bottom: 0.33rem;
	}
	
	.modal1 .modal-content .p3 {
		margin-bottom: 0.6rem;
	}
	
	.modal1 .modal-content p {
		font-size: 0.18rem;
	}
	
	.modal1 .modal-content .close {
		z-index: 999;
		position: absolute;
		right: 2px;
		top: -4px;
		text-align: center;
		color: #262E31;
		font-size: 22px;
		transition: all 0.3s;
	}
	
	.modal1 .modal-content .close:hover,
	.close:focus {
		color: #95b4ed;
		text-decoration: none;
		cursor: pointer;
	}
</style>


// WEBPACK FOOTER //
// src/default_home.vue